import { render, staticRenderFns } from "./CreatePlayerPage.vue?vue&type=template&id=424cbb5e&"
import script from "./CreatePlayerPage.vue?vue&type=script&lang=js&"
export * from "./CreatePlayerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports